import { I as t } from "../../constants-DeVuDy8J.js";
import { openBlock as d, createElementBlock as n, normalizeClass as o, createElementVNode as l } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconClipboardCheck",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(t).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, u = ["aria-label", "data-qa", "aria-hidden"];
function m(e, r, i, h, p, a) {
  return d(), n("svg", {
    "aria-label": i.ariaLabel,
    class: o([a.iconSizeClass, "d-icon d-icon--clipboard-check"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Clipboard Check",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [...r[0] || (r[0] = [
    l("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M7.854 5.646a.5.5 0 0 1 0 .708l-2 2a.5.5 0 0 1-.708 0l-1-1a.5.5 0 1 1 .708-.708l.646.647 1.646-1.647a.5.5 0 0 1 .708 0Z",
      fill: "currentColor"
    }, null, -1),
    l("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M3.5 1.5a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1H9A1.5 1.5 0 0 1 10.5 3v7A1.5 1.5 0 0 1 9 11.5H3A1.5 1.5 0 0 1 1.5 10V3A1.5 1.5 0 0 1 3 1.5h.5Zm4 2a1 1 0 0 0 1-1H9a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5V3a.5.5 0 0 1 .5-.5h.5a1 1 0 0 0 1 1h3Zm-3-2h3v1h-3v-1Z",
      fill: "currentColor"
    }, null, -1)
  ])], 10, u);
}
const b = /* @__PURE__ */ s(c, [["render", m]]);
export {
  b as default
};
//# sourceMappingURL=clipboard-check.js.map
